import { render, staticRenderFns } from "./DownloadRefusedEvidence.vue?vue&type=template&id=2822039b&scoped=true"
import script from "./DownloadRefusedEvidence.vue?vue&type=script&lang=js"
export * from "./DownloadRefusedEvidence.vue?vue&type=script&lang=js"
import style0 from "./DownloadRefusedEvidence.vue?vue&type=style&index=0&id=2822039b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822039b",
  null
  
)

export default component.exports